<header
  class="safe-top sticky top-0 z-30 border-b bg-background/95 px-3 pb-2 pt-3 backdrop-blur supports-[backdrop-filter]:bg-background/60"
>
  <div class="mx-auto flex max-w-xl min-h-14 items-center gap-2">
    @if (showBurger) {
      <button
        type="button"
        class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-border text-muted-foreground"
        (click)="burgerToggle.emit()"
        [attr.aria-label]="'nav.menu' | translate"
      >
        <span class="material-icons text-base" aria-hidden="true">menu</span>
      </button>
    } @else if (logoSrc) {
      <img [src]="logoSrc" alt="" class="h-7 w-auto shrink-0" width="120" height="36" decoding="async" />
    }
    @if (showBackToApps && !showBurger) {
      <button
        type="button"
        class="shrink-0 rounded-lg border border-border px-2 py-1 text-xs text-muted-foreground"
        (click)="onBackToApps()"
      >
        {{ "nav.apps" | translate }}
      </button>
    }
    <h1 class="min-w-0 flex-1 truncate font-heading text-lg font-semibold">
      @if (titleText) {
        {{ titleText }}
      } @else {
        {{ titleKey | translate }}
      }
    </h1>
    @if (showLogout) {
      <button
        type="button"
        (click)="logout.emit()"
        class="shrink-0 rounded-lg border px-3 py-1 text-sm text-muted-foreground"
      >
        {{ "auth.logout" | translate }}
      </button>
    }
  </div>
</header>
